module.exports = __webpack_public_path__ + "static/img/ph.a5cb5e63.svg";